import { FormControl, OutlinedTextFieldProps, TextField } from '@mui/material'
import uniqueId from 'lodash/uniqueId'
import { FormViewerFieldMetadata } from '@omnea-app/fe-form-viewer/types'

export interface LabeledTextFieldType extends Omit<OutlinedTextFieldProps, 'variant'> {
  label: string
  required?: boolean
  dataTestId?: string
  endAdornment?: React.ReactNode
  readOnly?: boolean
  labelTooltip?: React.ReactNode
  slotProps?: OutlinedTextFieldProps['slotProps']
  fieldMetadata?: FormViewerFieldMetadata
  fullWidth?: boolean
}

export function LabeledTextField(props: LabeledTextFieldType) {
  const {
    label,
    required,
    endAdornment,
    readOnly,
    labelTooltip,
    slotProps,
    dataTestId,
    fieldMetadata,
    fullWidth = true,
    ...otherProps
  } = props
  const labelId = uniqueId(`${label}-label-`)
  return (
    <FormControl fullWidth={fullWidth}>
      <TextField
        id={labelId}
        data-is-ai-prefilled={fieldMetadata?.isAiPrefilled}
        label={
          label ? (
            <>
              {label}
              {labelTooltip}
            </>
          ) : undefined
        }
        required={required}
        variant="outlined"
        {...otherProps}
        data-testid={dataTestId}
        slotProps={
          slotProps ?? {
            input: { id: labelId, endAdornment, readOnly },
          }
        }
      />
    </FormControl>
  )
}
